<template>
    <div class="main">
        <download-Popup></download-Popup>
        <p class="operamini-tips" v-if="isOperamini">Untuk memberi Anda pengalaman yang lebih baik, silakan unduh
            aplikasi profesional kami.</p>

        <navVue :subtitleData="getHomeSubTabList" :navSelected="currentNavTag" />
        <div class="contentWrap" id="contentWrap">
            <!-- 没有数据 -->
            <nodata v-if="getNoDataMode" :whiteMode="true"></nodata>
            <!-- loading -->
            <loading v-if="getLoadingShow" />

            <carousel v-if="subtitChoose === 'Headline'" :carouselImgData="getCarouselData" :firstTit="firstTit"
                :subtit="subtitChoose" />

            <transfer-entrance v-if="subtitChoose == 'Headline'" />

            <div class="listwrap" v-if="!getNoDataMode && !getLoadingShow">
                <div class="list" v-for="(data, index) in getCurrentListData" :key="index">
                    <router-link
                        :to="{ path: `/news/${getUrlTitle(subtitChoose)}/${getUrlTitle(data.title)}/${data.id}` }">
                        <list-item :listData="data" :firstTit="firstTit" :subtit="subtitChoose"></list-item>
                    </router-link>
                </div>

                <p v-if="isOperamini" class="operamini-tips">
                    Untuk memberi Anda pengalaman yang lebih baik, gunakan mode normal untuk mengunjungi situs web kami.
                </p>

                <loading v-if="!!getLoadNext" ref="loadingRef" />
                <div v-if="!getLoadNext" class="noMoreDatas"> Tidak Ada Data Lagi</div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
import axios from 'axios'
import { mapGetters } from 'vuex'
import homeLoadMoreMixin from '../mixins/homeLoadMoreMixin'

import navVue from '@/components/navNew.vue'
import carousel from '@/components/carousel.vue'
import transferEntrance from '@/components/transferEntrance.vue'
import listItem from '@/components/listItem.vue'
import loading from '@/components/loading.vue'
import nodata from '@/components/nodata.vue'
import downloadPopup from '@/components/downloadPopup.vue'

export default {
    name: 'home',
    mixins: [homeLoadMoreMixin()],
    components: {
        listItem,
        carousel,
        transferEntrance,
        navVue,
        loading,
        nodata,
        downloadPopup
    },
    data() {
        return {
            initUrl: '/m/app/global/2/m_new.json?plat=m',
            currentNavTag: 'BERITA',
            subtitData: [],
            scrollLeft: 0, // 记录滚动条长度
            leftToScreen: 0, // 点击元素距离屏幕左侧距离
            rightToScreen: 0, // 点击元素距离屏幕右侧距离
            _start: 0,
            _end: 0,
            firstTit: 'News',
            subtitle: '',
            transformY: '',
            inTime: null,
            beforeLeaveToNew: null,
            isOperamini: false
        }
    },

    computed: {
        ...mapGetters([
            'getHomeSubTabList',
            'getLoading',
            'getCarouselData',
            'getNoDataMode',
            'getLoadingShow',
            'getCurrentListData',
            'getLoadPrev',
            'getLoadNext'
        ]),
        subtitChoose() {
            return this.$store.state.navStore.subtitChoose
        }
    },
    asyncData({ store, route: { params: { subtitle } } }) {
        // 此函数会在组件实例化之前执行，故直接将store,route传入；
        // return store.dispatch('menusListApi');
        // // 多个时的写法
        // return Promise.all([
        //     store.dispatch('menusListApi'),
        //     store.dispatch("FETCH_COMMENTS",id)
        // ])

        const allFetch = async () => {
            // 重进页面保持在离开之前的滚动位置
            if (store.getters.getCurrentListData.length > 0) return

            const menus = await store.dispatch('menusListApi', { subtitle, type: 'BERITA' })
            const chooseArr = store.getters.getHomeSubTabList.filter(ele => ele.label === store.state.navStore.subtitChoose)

            const newsList = await store.dispatch('newsListApi', ...chooseArr)
            return Promise.all([
                menus,
                newsList
            ])
        }
        return allFetch()
    },

    head() {
        const referer = this.subtitChoose === 'Headline' ? 'Football' : 'Football' + this.subtitChoose
        const HOST = process.env.NODE_ENV === 'production' ? 'https://m-yinni.allsepakbola.net' : 'https://beta-m-yinni.allfootballapp.com'

        return {
            title: `${referer} News | All Sepakbola`,
            link: [{
                rel: 'amphtml',
                href: HOST + '/amp' + this.$route.fullPath
            }],
            meta: [
                {
                    name: 'description',
                    content: `The best football community for football fans only, providing the ${referer} news, transfer rumours, commentary, match reports`
                },
                {
                    name: 'keywords',
                    content: `${referer}, ${referer} news, transfer rumours, commentary, match reports`
                }
            ]
        }
    },

    beforeRouteEnter(to, from, next) {
        if (from.meta.scrollToTop && from.path === '/news') {
            document.title = from.meta.title
        }

        next(vm => {
            vm.inTime = new Date()
        })
    },

    beforeRouteLeave(to, from, next) {
        if (to.meta.scrollToTop) {
            document.title = to.meta.title
        }

        next()
    },

    mounted() {
        let utilObj = require('@/util/util.js')
        utilObj.timeForInOut()
        this.isOperamini = utilObj.checkOperamini()
    },

    methods: {
        handleStickyHeader() {
            const userAgent = navigator.userAgent.toLowerCase()
            const isAndroid = userAgent.includes('android')

            if (!isAndroid) return

            const topFixedWrap = document.getElementById('topFixedWrap')
            if (!topFixedWrap) return

            const topFixedWrapHeight = topFixedWrap.offsetHeight// 被定住的位置的高度

            const headHeight = 0// 下载条的高度
            const contentWrap = document.getElementById('contentWrap')// 每个二级导航下的列表内容

            if (this.containerTop >= headHeight) {
                topFixedWrap.className = 'topFixedWrap tab-box-fixed'
                contentWrap.style.paddingTop = topFixedWrapHeight + 'px'
            } else {
                topFixedWrap.className = 'topFixedWrap'
                contentWrap.style.paddingTop = 0 + 'px'
            }
        },

        async loadData() {
            if (!this.getLoadNext) return

            try {
                this.$store.commit('setLoading', true)
                const url = global.apiDomain + this.getLoadNext

                const res = await axios.get(url)
                const { articles, next } = res.data

                if (articles) {
                    this.$store.commit('SET_LIST_DATA', [...this.getCurrentListData, ...articles])
                }

                const cNext = next ? next.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '') : ''

                this.$store.commit('setLoadNext', cNext)
                this.$store.commit('setLoading', false)
            } catch (err) {
                this.loadingError()
                this.$store.commit('setLoading', false)
            }
        },

        loadingError() {
            let loadingWord = document.getElementById('loadingWord')
            loadingWord.innerHTML = 'ERROR'
        },

        updateTitle() {
            if (this.subtitChoose === 'Headline') {
                document.title = 'All Sepakbola - Live Scores, News, Videos & Highlights'
            } else {
                document.title = 'All Sepakbola - ' + this.subtitChoose + ' Live Scores, News, Videos & Highlights'
            }
        }
    }
}
</script>
<style lang="less" scoped>
html {
    min-height: 100%;
}

.clearfix:after {
    visibility: hidden;
    display: block;
    font-size: 0;
    content: " ";
    clear: both;
    height: 0;
}

.clearfix {
    *zoom: 1;
}

.clear {
    clear: both;
}

html::-webkit-scrollbar {
    display: none;
}

body::-webkit-scrollbar {
    display: none;
}

.main::-webkit-scrollbar {
    display: none;
}

.list a {
    color: #2d2f32;
    display: block;
}

.list a {
    &:visited {
        color: #888;
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .3s
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */
    {
    opacity: 0
}

.noMoreDatas {
    font-size: 1rem;
    text-align: center;
    line-height: 1rem;
    padding: 1rem 0;
    color: #b5bcc4;
    display: block;
}


.operamini-tips {
    background: #FFFF00;
    text-align: center;
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// AppHome.vue?1c711a30